import { NINETY_DAYS_MS } from './constants';

// --- Facebook ---
// The _fbc cookie format is `fb.1.{timestamp_ms}.{fbclid}`. These helpers parse
// the embedded fbclid and validate the timestamp against the 90-day attribution
// window.

export const extractFbclidFromFbc = (fbc: string): string | null => {
	try {
		const parts = fbc.split('.');
		return parts.length >= 4 ? parts[3] : null;
	} catch (e) {
		return null;
	}
};

export const isFbcExpired = (fbc: string): boolean => {
	try {
		const parts = fbc.split('.');

		if (parts.length < 4) return true;

		const timestamp = Number(parts[2]);

		if (Number.isNaN(timestamp)) return true;

		return Date.now() - timestamp > NINETY_DAYS_MS;
	} catch (e) {
		return true;
	}
};
